<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="backwhite border-rd3 flexleft"
      style="min-height: 120px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm width90 flex"
      >
        <el-form-item label="选择人员">
          <el-select
            v-model="ruleForm.patent_type"
            placeholder="请选择人员"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in options"
              :key="item.realname"
              :label="item.user.realname"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择年度" prop="patent_type">
          <el-date-picker
            v-model="ruleForm.inputyear"
            type="monthrange"
            style="width: 50%"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <p class="width98 margin-auto pad-bot10 margin-left30">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >检 索</el-button
        >
        <el-button @click="resetForm('ruleForm')" class="resetbtn"
          >重 置</el-button
        >
        <el-button @click="exportForm('ruleForm')">导出</el-button>
        <el-button @click="removechangeall()">批量删除</el-button>
        <el-button @click="generate()">生成工资流水</el-button>
        <el-button @click="detailmonth()">按月分组查询明细</el-button>
        <el-button @click="detailproject()">按项目查询明细</el-button>
      </p>
    </div>
    <el-skeleton
      class="width100 backwhite margin-top15 pad-top20 border-rd3 alldigitalt"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div class="width98 margin-auto backwhite">
          <el-table
            :data="page"
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            stripe
            class="eltable width100 margin-auto f14"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              label="月份"
              align="center"
              v-if="columns[8].visible"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.month }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="项目名称"
              align="center"
              v-if="columns[0].visible"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.title == null ? "***" : scope.row.title
                }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="人员姓名"
              align="center"
              v-if="columns[1].visible"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.realname }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="工作权重"
              align="center"
              prop="weight"
              v-if="columns[2].visible"
            />
            <el-table-column
              label="项目角色"
              align="center"
              prop="role"
              v-if="columns[3].visible"
            />
            <el-table-column
              label="起止日期"
              align="center"
              width="250"
              v-if="columns[9].visible"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.start_date }}--{{ scope.row.end_date }}</span
                ></template
              ></el-table-column
            >
            <el-table-column
              label="工作天数"
              align="center"
              prop="days"
              v-if="columns[4].visible"
            />
            <el-table-column
              label="金额（元）"
              align="center"
              prop="amount"
              v-if="columns[5].visible"
            />
            <el-table-column
              label="生成时间"
              align="center"
              prop="end_date"
              width="150"
              v-if="columns[6].visible"
            />
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              v-if="columns[7].visible"
            >
              <template slot-scope="scope">
                <div class="cursorpointer">
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="designDetail(scope.row)"
                    >删除</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20 pad-left10 pad-right10
            "
            v-if="total != 0"
          >
            <span class="bluecolor f14"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
    <!-- 生成工资流水弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleRunning"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
    >
      <p class="textalign-left f16">工资流水</p>
      <div class="margin-top30 pad-bot20">
        <div class="textalign-left">
          <div class="waterbor" v-if="waterindex == 1">
            <div class="width90 margin-auto margin-top30 pad-bot30">
              <p class="maincolor f16">请选择要生成工资单月份</p>
              <div class="width100 margin-top20">
                <el-date-picker
                  style="width: 100%"
                  v-model="inputmonth"
                  type="month"
                  placeholder="选择日期"
                  value-format="yyyy-MM"
                >
                </el-date-picker>
              </div>
              <div class="margin-top20 border-rd3" style="background: #88cace">
                <div
                  class="width90 margin-auto lineheight25 pad-top10 pad-bot10"
                >
                  工资报表每月1日自动生成，当员工信息变化时，可调整信息后重新手动生成一次正确的工资表。
                </div>
              </div>
              <div class="margin-top20">
                <el-button type="primary" @click="generatemoney()"
                  >生成工资流水</el-button
                >
                <el-button
                  @click="dialogVisibleRunning = false"
                  class="resetbtn"
                  >取 消</el-button
                >
              </div>
            </div>
          </div>
          <div class="waterbor pad-bot30" v-if="waterindex == 2">
            <div class="loading"></div>
            <p class="maincolor f16 textalign-center pad-top20">
              正在生成{{ inputmonth }}月工资流水，请稍候
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 按月份查询明细弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetailmonth"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :width="detailmonthwidth"
    >
      <p class="textalign-left f16">明细</p>
      <div class="margin-top30 pad-bot20">
        <div class="textalign-left">
          <div class="waterbor" v-if="detailindex == 1">
            <div class="width90 margin-auto margin-top30 pad-bot30">
              <p class="maincolor f16">请选择要查询的区间</p>
              <div class="width100 margin-top20">
                <el-date-picker
                  v-model="yearsection"
                  type="monthrange"
                  style="width: 50%"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
              <div
                class="margin-top20 border-rd3"
                style="background: #52c5cc80"
              >
                <div
                  class="width90 margin-auto lineheight25 pad-top10 pad-bot10"
                >
                  采用按月分组展示研发工资明细。
                </div>
              </div>
              <div class="margin-top20">
                <el-button type="primary" @click="detailmonthmoney()"
                  >查看工资表</el-button
                >
                <el-button
                  @click="dialogVisibledetailmonth = false"
                  class="resetbtn"
                  >取 消</el-button
                >
              </div>
            </div>
          </div>
          <div class="waterbor pad-bot30" v-if="detailindex == 2">
            <div class="loading"></div>
            <p class="maincolor f16 textalign-center pad-top20">
              正在查询{{
                yearsection[0] + " - " + yearsection[1]
              }}工资明细，请稍候
            </p>
          </div>

          <div class="waterbor pad-bot30" v-if="detailindex == 3">
            <div class="width94 margin-auto f14" id="printTests">
              <p class="maincolor margin-top20 pad-bot10 borderbot">
                工资明细区间: {{ yearsection[0] + " - " + yearsection[1] }}
              </p>
              <div v-for="(item, index) in detailmonthcont" :key="index">
                <p class="maincolor margin-top10 margin-bot10">
                  月份:{{
                    detailmonthcont[index].list[0].start_date.substring(0, 7)
                  }}
                </p>
                <table class="width100 textalign-center">
                  <tr class="textalign-center">
                    <td class="width15 bordernone backtd">人员姓名</td>
                    <td class="width10 bordernone backtd">工作权重</td>
                    <td class="width15 bordernone backtd">项目角色</td>
                    <td class="width30 bordernone backtd">起止日期</td>
                    <td class="width15 bordernone backtd">工作天数</td>
                    <td class="width15 bordernone backtd">金额</td>
                  </tr>
                  <tr v-for="(_item, _index) in item.list" :key="_index">
                    <td class="width15 textalign-left">{{ _item.realname }}</td>
                    <td class="width10 textalign-right">{{ _item.weight }}</td>
                    <td class="width15">{{ _item.role }}</td>
                    <td class="width30">
                      {{ _item.start_date }} - {{ _item.end_date }}
                    </td>
                    <td class="width15">{{ _item.days }}</td>
                    <td class="width15 borderrightnone textalign-right">
                      {{ _item.amount }}
                    </td>
                  </tr>
                  <tr>
                    <td class="width15">总计</td>
                    <td class="width70" colspan="4"></td>
                    <td class="width15 borderrightnone textalign-right">
                      {{ item.total }}
                    </td>
                  </tr>
                </table>
              </div>
              <p class="maincolor margin-top20">
                项目工资合计总额: {{ monthtotal }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="textalign-right" v-if="detailindex == 3">
        <el-button type="primary" v-print="'#printTests'" @click="Savechanges()"
          >打 印</el-button
        >
        <el-button @click="dialogVisibledetailmonth = false">取 消</el-button>
      </p>
    </el-dialog>
    <!-- 按项目查询明细弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleproject"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :width="projectwidth"
    >
      <p class="textalign-left f16">明细</p>
      <div class="margin-top30 pad-bot20">
        <div class="textalign-left">
          <div class="waterbor" v-if="projectindex == 1">
            <div class="width90 margin-auto margin-top30 pad-bot30">
              <p class="maincolor f16">请选择要查询的区间</p>
              <div class="width100 margin-top20">
                <el-select
                  style="width: 100%"
                  v-model="projectvalue"
                  placeholder="请选择"
                  @change="projectchange($event)"
                >
                  <el-option
                    style="width: 100%"
                    v-for="item in projectoptions"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="margin-top20 border-rd3"
                style="background: #52c5cc80"
              >
                <div
                  class="width90 margin-auto lineheight25 pad-top10 pad-bot10"
                >
                  研发项目工资明细，采用按月分组展示。
                </div>
              </div>
              <div class="margin-top20">
                <el-button type="primary" @click="projectmoney()"
                  >查看工资表</el-button
                >
                <el-button
                  @click="dialogVisibleproject = false"
                  class="resetbtn"
                  >取 消</el-button
                >
              </div>
            </div>
          </div>
          <div class="waterbor pad-bot30" v-if="projectindex == 2">
            <div class="loading"></div>
            <p class="maincolor f16 textalign-center pad-top20">
              项目名称:{{ projecttitle }}
            </p>
          </div>

          <div class="waterbor pad-bot30" v-if="projectindex == 3">
            <div class="width94 margin-auto f14" id="printTestss">
              <p class="maincolor margin-top20 pad-bot10 borderbot">
                项目名称:{{ projecttitle }}
              </p>
              <div v-for="(item, index) in projectcont" :key="index">
                <p class="maincolor margin-top10 margin-bot10">
                  月份:{{
                    projectcont[index].list[0].start_date.substring(0, 7)
                  }}
                </p>
                <table class="width100 textalign-left">
                  <tr class="textalign-center">
                    <td class="width15 bordernone backtd">人员姓名</td>
                    <td class="width10 bordernone backtd">工作权重</td>
                    <td class="width15 bordernone backtd">项目角色</td>
                    <td class="width30 bordernone backtd">起止日期</td>
                    <td class="width15 bordernone backtd">工作天数</td>
                    <td class="width15 bordernone backtd">金额</td>
                  </tr>
                  <tr v-for="(_item, _index) in item.list" :key="_index">
                    <td class="width15 textalign-left">{{ _item.realname }}</td>
                    <td class="width10 textalign-right">{{ _item.weight }}</td>
                    <td class="width15">{{ _item.role }}</td>
                    <td class="width30">
                      {{ _item.start_date }} - {{ _item.end_date }}
                    </td>
                    <td class="width15">{{ _item.days }}</td>
                    <td class="width15 borderrightnone textalign-right">
                      {{ _item.amount }}
                    </td>
                  </tr>
                  <tr>
                    <td class="width15">总计</td>
                    <td class="width70" colspan="4"></td>
                    <td class="width15 borderrightnone textalign-right">
                      {{ item.total }}
                    </td>
                  </tr>
                </table>
              </div>
              <p class="maincolor margin-top20">
                项目工资合计总额: {{ projecttotal }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="textalign-right" v-if="projectindex == 3">
        <el-button
          type="primary"
          v-print="'#printTestss'"
          @click="Savechanges()"
          >打 印</el-button
        >
        <el-button @click="dialogVisibleproject = false">取 消</el-button>
      </p>
    </el-dialog>
  </div>
</template>
  <script>
import {
  entrdwageindex,
  entrdwagecreate,
  entrdwagedelete,
  entrdwagebydate,
  entrdwagebyproject,
  researchprojects,
} from "@/api/newhead/newhead.api";
import { bindstafflist } from "@/api/loader/loder.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";

export default {
  data() {
    return {
      loading: true,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleRunning: false,
      dialogVisibledetailmonth: false,
      dialogVisibleproject: false,
      ruleForm: {
        inputyear: "",
        patent_type: "",
      },
      inputmonth: "",
      waterindex: 1,
      yearsection: "",
      detailindex: 1,
      detailmonthwidth: 30 + "%",
      detailmonthcont: [],
      monthtotal: 0,

      projectindex: 1,
      projectwidth: 30 + "%",
      projectvalue: "",
      projectoptions: [],
      projectcont: [],
      projecttitle: "",
      projecttotal: 0,

      options: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      serchkey: true,
      input: "",
      multipleSelection: [],
      columns: [
        { key: 0, label: `名称`, visible: true },
        { key: 1, label: `人员姓名`, visible: true },
        { key: 2, label: `工作权重`, visible: true },
        { key: 3, label: `项目角色`, visible: true },
        { key: 4, label: `工作天数`, visible: true },
        { key: 5, label: `金额`, visible: true },
        { key: 6, label: `生成时间`, visible: true },
        { key: 7, label: `操作`, visible: true },
        { key: 8, label: `月份`, visible: true },
        { key: 9, label: `起止日期`, visible: true },
      ],
    };
  },

  components: {
    callback,
    switchcore,
  },

  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    submitForm() {
      if (this.ruleForm.inputyear == "") {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          between:
            this.ruleForm.inputyear[0] + " - " + this.ruleForm.inputyear[1],
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    exportForm(formName) {
      if (this.ruleForm.inputyear == "") {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          export: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          between:
            this.ruleForm.inputyear[0] + " - " + this.ruleForm.inputyear[1],
          export: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // input重 置
    resetForm(formName) {
      this.ruleForm.inputyear = "";
      this.ruleForm.patent_type = "";
      this.thisNum = 1;
      entrdwageindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 生成工资流水
    generate() {
      this.dialogVisibleRunning = true;
      this.waterindex = 1;
    },
    generatemoney() {
      this.waterindex = 2;
      entrdwagecreate({
        month: this.inputmonth,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleRunning = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    projectchange(value) {
      this.projectoptions.forEach((i) => {
        if (i.id == value) {
          this.projecttitle = i.title;
        }
      });
    },
    // 按月份查询明细
    detailmonth() {
      this.dialogVisibledetailmonth = true;
      this.detailindex = 1;
      this.detailmonthwidth = 30 + "%";
      this.this.monthtotal = 0;
    },
    detailmonthmoney() {
      if (this.yearsection != "") {
        this.detailindex = 2;
        entrdwagebydate({
          between: this.yearsection[0] + " - " + this.yearsection[1],
        }).then((res) => {
          if (res.data.code == 200) {
            this.detailindex = 3;
            this.detailmonthwidth = 50 + "%";
            this.detailmonthcont = Object.values(res.data.data);
            this.detailmonthcont.forEach((i) => {
              this.monthtotal = this.monthtotal + i.total;
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },
    // 按项目查询明细
    detailproject() {
      this.dialogVisibleproject = true;
      this.projectindex = 1;
      this.projectwidth = 30 + "%";
      this.projecttotal = 0;
    },
    projectmoney() {
      if (this.projectvalue != "") {
        this.projectindex = 2;
        entrdwagebyproject({
          project_id: this.projectvalue,
        }).then((res) => {
          if (res.data.code == 200) {
            this.projectindex = 3;
            this.projectwidth = 50 + "%";
            this.projectcont = Object.values(res.data.data);
            this.projectcont.forEach((i) => {
              this.projecttotal = this.projecttotal + i.total;
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },
    // 批量删除
    removechangeall() {
      let Selectionid = [];
      this.multipleSelection.forEach((i) => {
        Selectionid.push(i.id);
      });
      this.$confirm("此操作将删除此项工资报表, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entrdwagedelete({ id: Selectionid }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除
    designDetail(row) {
      this.$confirm("此操作将删除此项工资报表, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entrdwagedelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      if (this.ruleForm.inputyear == "") {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          between:
            this.ruleForm.inputyear[0] + " - " + this.ruleForm.inputyear[1],
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    handleSizeChange(val) {
      if (this.ruleForm.inputyear == "") {
        entrdwageindex({
          user_id: this.ruleForm.patent_type,
          page: 1,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entrdwageindex({
          page: 1,
          limit: val,
          user_id: this.ruleForm.patent_type,
          between:
            this.ruleForm.inputyear[0] + " - " + this.ruleForm.inputyear[1],
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    refresh() {
      this.$loading.show(); // 显示loading
      if (this.ruleForm.inputyear == "") {
        entrdwageindex({
          page: this.thisNum,
          user_id: this.ruleForm.patent_type,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entrdwageindex({
          page: this.thisNum,
          user_id: this.ruleForm.patent_type,
          between:
            this.ruleForm.inputyear[0] + " - " + this.ruleForm.inputyear[1],
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("navigetionval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("navigetionval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("navigetionval")
      );
    }

    entrdwageindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    bindstafflist({}).then((res) => {
      if (res.data.code == 200) {
        this.options = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    researchprojects({}).then((res) => {
      if (res.data.code == 200) {
        this.projectoptions = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>
  <style scoped>
/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTests {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}

@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTestss {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}
.el-col-4 {
  width: 26%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
.waterbor {
  width: 100%;
  min-height: 250px;
  border: 1px solid #a8b1c2;
  border-radius: 3px;
}

.loading {
  width: 100px;
  height: 100px;
  border: 2px solid #52c5cb;
  margin: 40px auto 20px;
  border-top-color: transparent;
  border-radius: 50%;
  animation: rotate 0.75s linear infinite;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

.maincolor {
  color: #52c5cb;
}

table {
  border: 1px solid #ecf8f9;
  border-collapse: collapse;
  border-spacing: 0;
}

th {
  padding: 0;
}
td {
  border-right: 1px solid #ecf8f9;
  border-top: 1px solid #ecf8f9;
  height: 40px;
  padding-left: 5px;
  padding-right: 5px;
}
.bordertopnone {
  border-top: none;
}
.borderrightnone {
  border-right: none;
}
.bordernone {
  border: none;
}
.backtd {
  background: #52c5cc80;
}
.borderbot {
  border-bottom: 2px solid #52c5cb;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>